import { useEffect, useRef } from 'react';
import { RETURN_UPDATE_EVENT, type ReturnUpdateDetail } from '@/lib/return-status';

/**
 * Ops simulation T03 — call `onUpdate` whenever a return changes on the
 * server (approved, rejected or failed), so a page can refetch without the
 * cashier refreshing. Raised by `useRealtimeNotifications`. Pass `billId` to
 * hear only about returns against that bill.
 */
export function useReturnUpdates(onUpdate: (detail: ReturnUpdateDetail) => void, billId?: string): void {
  const callbackRef = useRef(onUpdate);
  callbackRef.current = onUpdate;

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = ((event as CustomEvent<ReturnUpdateDetail>).detail ?? {}) as ReturnUpdateDetail;
      if (billId && detail.bill_id && detail.bill_id !== billId) return;
      callbackRef.current(detail);
    };
    window.addEventListener(RETURN_UPDATE_EVENT, handler);
    return () => window.removeEventListener(RETURN_UPDATE_EVENT, handler);
  }, [billId]);
}
